import { Field } from '@/components/Field';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { useSimulatorState } from '@/store/useSimulatorState';

/**
 * Métadonnées libres du scénario : titre et description. Purement descriptif,
 * n'entre pas dans les calculs — affiché en tête de page et repris dans les exports.
 */
export function InfoPanel() {
  const info = useSimulatorState((s) => s.info);
  const updateInfo = useSimulatorState((s) => s.updateInfo);

  return (
    <div className="flex flex-col gap-4 py-2">
      <Field
        id="scenarioTitle"
        label="Titre du scénario"
        tooltip="Nom affiché en tête de page et utilisé comme titre dans les exports."
      >
        <Input
          id="scenarioTitle"
          value={info?.title ?? ''}
          onChange={(e) => updateInfo({ title: e.target.value })}
          placeholder="Ex : SaaS B2B — hypothèse prudente"
          maxLength={120}
        />
      </Field>
      <Field
        id="scenarioDescription"
        label="Description"
        tooltip="Note libre pour contextualiser le scénario (hypothèses, marché, objectifs…)."
      >
        <Textarea
          id="scenarioDescription"
          value={info?.description ?? ''}
          onChange={(e) => updateInfo({ description: e.target.value })}
          placeholder="Décrivez les hypothèses et le contexte de ce scénario…"
          rows={5}
          maxLength={2000}
        />
      </Field>
    </div>
  );
}
